import type { enOrder } from '../en/order';

export const idOrder: Record<keyof typeof enOrder, string> = {
  // ---- Denah ----------------------------------------------------------------------
  'floor.empty': 'Belum ada meja — tambahkan lantai dan meja di back office.',
  'floor.filter': 'Lantai',
  'floor.tileLabel': 'Meja {name}, {status}',
  'floor.capacity': '{count} kursi',
  'floor.guests': '{count} tamu',
  'floor.newOrders': '{count} pesanan baru dari tamu',
  'floor.newOrdersShort': 'Baru',
  'floor.openFor': 'Dibuka {minutes} mnt',
  'floor.needsRelease': 'Lepas setelah dibersihkan',
  'floor.guestCount': 'Jumlah tamu',
  'floor.openTitle': 'Buka meja {name}',
  'floor.open': 'Buka meja',
  'floor.opening': 'Membuka…',
  'floor.opened': 'Meja {name} dibuka.',
  'floor.release': 'Meja sudah bersih — lepas',
  'floor.releasing': 'Melepas…',
  'floor.released': 'Meja {name} tersedia lagi.',
  'floor.noSessionTitle': 'Meja {name} belum dibuka',
  'floor.noSessionText': 'Buka meja dengan jumlah tamu untuk mulai mencatat pesanan.',
  'floor.outOfService': 'Meja ini tidak dipakai. Manajer dapat mengaktifkannya di back office.',
  'floor.cleaningText': 'Tagihan sudah lunas. Lepas meja setelah selesai dibersihkan.',
  'floor.reservedText': 'Meja ini sudah dipesan.',
  'floor.backToFloor': 'Kembali ke denah',
  'floor.notFound': 'Meja ini tidak ada di cabang ini.',
  'floor.sessionSummary': '{guests} tamu · dibuka {minutes} mnt',
  'floor.serverName': 'Pelayan: {name}',

  // ---- Jumlah ---------------------------------------------------------------------
  'order.qty.label': 'Jumlah',
  'order.qty.decrease': 'Kurangi',
  'order.qty.increase': 'Tambah',
  'order.qty.decreaseItem': 'Kurangi jumlah {name}',
  'order.qty.increaseItem': 'Tambah jumlah {name}',

  // ---- Menu -----------------------------------------------------------------------
  'order.menu.title': 'Menu',
  'order.menu.empty': 'Menu masih kosong — tambahkan kategori dan item di back office.',
  'order.menu.categories': 'Kategori menu',
  'order.menu.search': 'Cari menu',
  'order.menu.noMatch': 'Tidak ada menu yang cocok.',
  'order.menu.hasOptions': 'Ada pilihan',
  'order.menu.outOfStock': 'Bahan habis',
  'order.menu.soldOut': 'Habis',
  'order.menu.added': '{name} ditambahkan.',

  // ---- Pilihan --------------------------------------------------------------------
  'order.mod.ruleOptional': 'Opsional · maks. {max}',
  'order.mod.ruleExact': 'Wajib · pilih {count}',
  'order.mod.ruleRange': 'Wajib · pilih {min}–{max}',
  'order.mod.errorMin': 'Pilih minimal {min}.',
  'order.mod.errorMax': 'Pilih maksimal {max}.',
  'order.mod.selected': '{count} dipilih',
  'order.mod.previewTotal': 'Perkiraan',
  'order.mod.add': 'Tambah ke pesanan',

  // ---- Catatan --------------------------------------------------------------------
  'order.notes.label': 'Catatan dapur',
  'order.notes.placeholder': 'mis. tanpa bawang, saus dipisah',
  'order.notes.shown': 'Catatan: {notes}',
  'order.notes.editItem': 'Ubah catatan {name}',
  'order.notes.title': 'Catatan untuk {name}',

  // ---- Keranjang ------------------------------------------------------------------
  'order.cart.title': 'Pesanan',
  'order.cart.number': 'No. {number}',
  'order.cart.empty': 'Belum ada item. Pilih dari menu.',
  'order.cart.drafts': 'Belum dikirim',
  'order.cart.sent': 'Sudah dikirim ke dapur',
  'order.cart.draftTotal': 'Belum dikirim',
  'order.cart.submittedTotal': 'Dipesan',
  'order.removeItem': 'Hapus {name}',
  'order.submit.action': 'Kirim ke dapur ({count})',
  'order.submit.pending': 'Mengirim…',
  'order.submit.done': 'Terkirim ke dapur.',
  'order.issue.title': 'Menu berubah sejak item ini ditambahkan. Hapus lalu tambahkan lagi:',
  'order.issue.price_changed': 'harga berubah',
  'order.issue.unavailable': 'tidak tersedia lagi',
  'order.issue.modifiers_changed': 'pilihan berubah',
  'order.issue.other': 'tidak sesuai menu lagi',
  'order.serve.select': 'Tandai {name} tersaji',
  'order.serve.action': 'Tandai tersaji ({count})',
  'order.serve.pending': 'Menyimpan…',
  'order.serve.done': 'Ditandai tersaji.',
  'order.cancel.action': 'Batalkan item',
  'order.cancel.title': 'Batalkan {name}?',
  'order.cancel.description': 'Item ini sudah dikirim ke dapur. Alasannya dicatat di jejak audit.',
  'order.cancel.reason': 'Alasan',
  'order.cancelOrder.action': 'Batalkan pesanan',
  'order.cancelOrder.title': 'Batalkan pesanan {label}?',
  'order.cancelOrder.body':
    'Semua item dibatalkan dan tiket dapurnya ditutup. Jika pesanan punya tagihan, batalkan tagihannya dulu.',
  'order.cancelOrder.pending': 'Membatalkan…',
  'order.cancelOrder.done': 'Pesanan {label} dibatalkan',
  'order.cancel.confirm': 'Batalkan item',
  'order.cancel.pending': 'Membatalkan…',
  'order.cancel.reasonShown': 'Dibatalkan: {reason}',

  // ---- Jenis pesanan & kanal (bawa pulang / delivery) ------------------------------
  'order.type.dine_in': 'Makan di tempat',
  'order.type.takeaway': 'Bawa pulang',
  'order.type.delivery': 'Delivery',
  'order.channel.walk_in': 'Langsung',
  'order.channel.gofood': 'GoFood',
  'order.channel.grabfood': 'GrabFood',
  'order.channel.shopeefood': 'ShopeeFood',
  'order.channel.other': 'Lainnya',
  'order.label.table': 'Meja {name}',
  'order.number': 'Pesanan {number}',
  'order.ref': 'No. pesanan platform {ref}',
  'order.customer': 'Pelanggan: {name}',
};
